import { Provider } from "@angular/core";
import { ENVIRONMENT } from "@kiraah-shared/environment";
import type { IEnvironmentInfo } from "@kiraah-shared/environment";
import { SHARED_LOGO_PATHS } from "@kiraah-shared/environment";
import { MOBILE_GATEWAY_URL } from "../auth/mobile-auth.config";

/** Minimal environment for unit tests (mobile HTTP + session). */
export const mobileTestEnvironment: IEnvironmentInfo = {
  AuthenticationMode: "INTERNAL_PASSWORD",
  Environment: "LOCAL",
  Api: { GatewayUrl: "http://localhost:8000/Kiraah.Gateway.Api" },
  WebAppUrl: "http://localhost:5174/#",
  InactivityDurationInMinutes: 5,
  WarningBeforeExpirationInMinutes: 2,
  Style: SHARED_LOGO_PATHS,
  DialogConfig: {
    ShowSuccess: true,
    ShowWarning: true,
    ShowError: true,
  },
  DateTime: {
    StorageFormat: "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'",
    DisplayFormats: {
      "fr-FR": "dd/MM/yyyy HH:mm:ss",
      "en-GB": "dd/MM/yyyy HH:mm:ss",
      "en-US": "MM/dd/yyyy hh:mm:ss a",
      "es-ES": "dd/MM/yyyy HH:mm:ss",
      "de-DE": "dd.MM.yyyy HH:mm:ss",
      "it-IT": "dd/MM/yyyy HH:mm:ss",
      "pt-PT": "dd/MM/yyyy HH:mm:ss",
    },
    DefaultCulture: "fr-FR",
    SupportedCultures: ["fr-FR", "en-US"],
  },
  Caching: { Enabled: false, InMemory: false },
};

export function provideMobileTestGateway(url = "http://localhost:8000/Kiraah.Gateway.Api"): Provider[] {
  return [
    { provide: ENVIRONMENT, useValue: mobileTestEnvironment },
    { provide: MOBILE_GATEWAY_URL, useValue: url },
  ];
}
